// Author YuJiaBei
// Date 2020-08-07 16:27:20

class EmArchToolKit {
constructor({
        id = null,
        emActProcessDefCode = '',
        emEquipmentCategoryId = '',
        emArchBasicDataCode = '',
        name = '',
        status = '',
        attachment = '',
        workContent = '',
        safetyPrecautions = '',
        staffingNeeds = '',
        toolNeeds = '',
        estimateDuration = '',
        emCycleUnitCode = '',
        periodicValue = '',
        isGeneral = '',
        remark = '',
        attachmentList = ''}
= {}) {
    this.id = id;
    this.emActProcessDefCode = emActProcessDefCode;
    this.emEquipmentCategoryId = emEquipmentCategoryId;
    this.emArchBasicDataCode = emArchBasicDataCode;
    this.name = name;
    this.status = status;
    this.attachment = attachment;
    this.workContent = workContent;
    this.safetyPrecautions = safetyPrecautions;
    this.staffingNeeds = staffingNeeds;
    this.toolNeeds = toolNeeds;
    this.estimateDuration = estimateDuration;
    this.emCycleUnitCode = emCycleUnitCode;
    this.periodicValue = periodicValue;
    this.isGeneral = isGeneral;
    this.remark = remark;
    this.attachmentList = attachmentList;
}
}

function newEntity() {
return new EmArchToolKit();
}

function gridFields() {
return Object.freeze([
        {
        key: 'emActProcessDefName',
        label: 'label.em.archive.emArchToolKit.grid.emActProcessDefName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emEquipmentCategoryName',
        label: 'label.em.archive.emArchToolKit.grid.emEquipmentCategoryName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emArchBasicDataName',
        label: 'label.em.archive.emArchToolKit.grid.emArchBasicDataName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.em.archive.emArchToolKit.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'authorId',
        label: 'label.em.archive.emArchToolKit.grid.authorId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'authorName',
        label: 'label.em.archive.emArchToolKit.grid.authorName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'reviewerId',
        label: 'label.em.archive.emArchToolKit.grid.reviewerId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'reviewerName',
        label: 'label.em.archive.emArchToolKit.grid.reviewerName',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'status',
        label: 'label.em.archive.emArchToolKit.grid.status',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '准备送审' },
                            { value: '2', text: '审批中' },
                            { value: '3', text: '审批通过' }
            ]
        }
        },
        {
        key: 'attachmentList',
        label: 'label.em.archive.emArchToolKit.grid.attachmentList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment'
        }
        },
        {
        key: 'workContent',
        label: 'label.em.archive.emArchToolKit.grid.workContent',
        sortable: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'safetyPrecautions',
        label: 'label.em.archive.emArchToolKit.grid.safetyPrecautions',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'staffingNeeds',
        label: 'label.em.archive.emArchToolKit.grid.staffingNeeds',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'toolNeeds',
        label: 'label.em.archive.emArchToolKit.grid.toolNeeds',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'estimateDuration',
        label: 'label.em.archive.emArchToolKit.grid.estimateDuration',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'emCycleUnitCode',
        label: 'label.em.archive.emArchToolKit.grid.emCycleUnitCode',
        sortable: true,
        form: {
        type: 'scheduledPeriodicUnit'
        }
        },
        {
        key: 'periodicValue',
        label: 'label.em.archive.emArchToolKit.grid.periodicValue',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'isGeneral',
        label: 'label.em.archive.emArchToolKit.grid.isGeneral',
        sortable: true,
        form: {
        type: 'boolean'
        }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchToolKit.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
]);
}

const filter = {
    emActProcessDefCodeFilter : "",
    emActProcessDefBusinessEntityFilter : "",
    emEquipmentCategoryIdFilter : "",
    emArchBasicDataCodeFilter : "",
    nameFilter : "",
    authorIdFilter : "",
    reviewerIdFilter : "",
    statusFilter : "",
    workContentFilter : "",
    estimateDurationGeFilter : "",
    estimateDurationLeFilter : "",
    emCycleUnitCodeFilter : "",
    periodicValueGeFilter : "",
    periodicValueLeFilter : "",
    isGeneralFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'emActProcessDefCodeFilter',
        label: 'label.em.archive.emArchToolKit.filter.emActProcessDefCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emActProcessDefinitionRegister'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'emEquipmentCategoryIdFilter',
        label: 'label.em.archive.emArchToolKit.filter.emEquipmentCategoryId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emEquipmentCategory'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'emArchBasicDataCodeFilter',
        label: 'label.em.archive.emArchToolKit.filter.emArchBasicDataCode',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emArchBasicData'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.em.archive.emArchToolKit.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'authorIdFilter',
        label: 'label.em.archive.emArchToolKit.filter.authorId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'reviewerIdFilter',
        label: 'label.em.archive.emArchToolKit.filter.reviewerId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.em.archive.emArchToolKit.filter.status',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '准备送审' },
                { value: '2', text: '审批中' },
                { value: '3', text: '审批通过' }
            ]
        }
        },
        {
        key: 'workContentFilter',
        label: 'label.em.archive.emArchToolKit.filter.workContent',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'estimateDurationGeFilter',
        label: 'label.em.archive.emArchToolKit.filter.estimateDurationGe',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'estimateDurationLeFilter',
        label: 'label.em.archive.emArchToolKit.filter.estimateDurationLe',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'emCycleUnitCodeFilter',
        label: 'label.em.archive.emArchToolKit.filter.emCycleUnitCode',
        disabled: false,
        form: {
        type: 'scheduledPeriodicUnit'
                }
        },
        {
        key: 'periodicValueGeFilter',
        label: 'label.em.archive.emArchToolKit.filter.periodicValueGe',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'periodicValueLeFilter',
        label: 'label.em.archive.emArchToolKit.filter.periodicValueLe',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'isGeneralFilter',
        label: 'label.em.archive.emArchToolKit.filter.isGeneral',
        disabled: false,
        form: {
        type: 'boolean'
                }
        }
];

const entityFormConfigs = [
        {
        key: 'emActProcessDefCode',
        label: 'label.em.archive.emArchToolKit.entity.emActProcessDefCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emActProcessDefinitionRegister'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'emEquipmentCategoryId',
        label: 'label.em.archive.emArchToolKit.entity.emEquipmentCategoryId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emEquipmentCategory'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'emArchBasicDataCode',
        label: 'label.em.archive.emArchToolKit.entity.emArchBasicDataCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'emArchBasicData'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'name',
        label: 'label.em.archive.emArchToolKit.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'status',
        label: 'label.em.archive.emArchToolKit.entity.status',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '准备送审' },
                { value: '2', text: '审批中' },
                { value: '3', text: '审批通过' }
            ]
        }
        },
        {
        key: 'workContent',
        label: 'label.em.archive.emArchToolKit.entity.workContent',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
            ,required: true
                }
        },
        {
        key: 'safetyPrecautions',
        label: 'label.em.archive.emArchToolKit.entity.safetyPrecautions',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'staffingNeeds',
        label: 'label.em.archive.emArchToolKit.entity.staffingNeeds',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'toolNeeds',
        label: 'label.em.archive.emArchToolKit.entity.toolNeeds',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'estimateDuration',
        label: 'label.em.archive.emArchToolKit.entity.estimateDuration',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
            ,required: true
                }
        },
        {
        key: 'emCycleUnitCode',
        label: 'label.em.archive.emArchToolKit.entity.emCycleUnitCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'scheduledPeriodicUnit'
                }
        },
        {
        key: 'periodicValue',
        label: 'label.em.archive.emArchToolKit.entity.periodicValue',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'isGeneral',
        label: 'label.em.archive.emArchToolKit.entity.isGeneral',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean'
                }
        },
        {
        key: 'remark',
        label: 'label.em.archive.emArchToolKit.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'attachmentList',
        label: 'label.em.archive.emArchToolKit.entity.attachment',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment'
            ,correspondingField: 'attachment'
                }
        }
]

export {EmArchToolKit, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
